<template>
  <div oncontextmenu="return false;">
    <nav class="navbar navbar-expand-xl navbar-expand-lg navbar-fixed-top">
      <button
        class="navbar-toggler toggler-example"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent1"
        aria-controls="navbarSupportedContent1"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="dark-blue-text">
          <img src="../assets/HamburgrMenu.svg" class="mt-3" alt="hamburger"/>
        </span>
      </button>

      <div class="collapse navbar-collapse" id="navbarSupportedContent1">
        <div class="heightcontainer">
          <div class="row no-gutters nav-height">
            <div class="col d-flex justify-content-between sidebar-backgroundheader">
              <div class="ml-5 mt-3 hover" @click="gotoMainPage()">
                <img src="../assets/Logo.svg" class="MainNewLogo" alt="logo" />
              </div>
              <div class="closemenuicon mt-4 mr-5 d-lg-none">
                <img
                  src="../assets/Hamburger_Back.svg"
                  id="hamburgerbackbtnclick"
                  class="img-fluid"
                  data-toggle="collapse"
                  alt="back"
                  data-target="#navbarSupportedContent1"
                  aria-controls="navbarSupportedContent1"
                  aria-expanded="false"
                />
              </div>
            </div>
          </div>
          <div class="sidebar-background">
            <div class="col-3 pl-3">
              <div class="row">
                <div class="ml-4 mt-sm-1 mt-md-1 mt-lg-4">
                  <div class="profilesummery pb-3">
                    <div class="col d-flex ml-3 profiledet">
                      <div class="mt-2" @click="openMainPage">
                        <img v-if="!profilePictureLink && !firstName" alt="profilepic" src="../assets/Profile_placehlder.svg" class="mr-2" />
                        <div v-if="!profilePictureLink && firstName" alt="profilepic" id="profImage" class=" text-center white fontsize14 profile-border rounded-circle white" :class="firstName.charAt(0)">
                          <p class="white fontsize14 defmargintop text-uppercase">{{firstName.charAt(0)}}</p>
                        </div>
                        <div v-if="profilePictureLink" class="profile-border">
                          <img  :src="profilePictureLink" alt="profilepic" oncontextmenu="return false" class=" rounded-circle loadingBgImg" width="40px" height="40px" @error="ErrorwithProfilePic()">
                        </div>
                      </div>
                      <div class="mt-2 pt-1 pr-2 ml-2 ">
                        <div @click="openMainPage" >
                          <div v-if="!firstName" class="hover">Profile Name</div>
                          <div v-else class="d-flex proximanova-semibold fontsize16 black80 text-capitalize hover fullName" id="nameBlock">
                            <div>{{fullName}}</div>
                          </div>
                        </div>
                        <div>
                          <div v-if="!designation">Designation</div>
                          <div v-else class="proximanova fontsize12 black80 text-capitalize" >{{designation}}</div>
                        </div>
                      </div>
                    </div>
                    <hr class="profhoriz"  v-if="userType !== 'InternalUser'">
                    <div class="ml-3"  v-if="userType !== 'InternalUser'">
                      <span class="fontsize12 proximanova-semibold black">Who viewed my</span>
                    </div>
                    <div class="col d-flex justify-content-between p-2 pl-3"  v-if="userType !== 'InternalUser'">
                      <div class="d-flex flex-column">
                        <span class="proximanova-semibold fontsize12 black60 text-nowrap">Profile</span>
                        <span class="proximanova fontsize16 blue viewhover" @click="navToProfileViews">{{profileViewsCount}}</span>
                      </div>
                      <div class="d-flex flex-column ml-3">
                        <span class="proximanova-semibold fontsize12 black60 text-nowrap">Video Profile</span>
                        <span class="proximanova fontsize16 blue viewhover" @click="navToProfileVideoViews">{{videoProfileviewsCount}}</span>
                      </div>
                      <div class="d-flex flex-column ml-3">
                        <span class="proximanova-semibold fontsize12 black60 text-nowrap">Resume Video</span>
                        <span class="proximanova fontsize16 blue viewhover">{{TotalVideosviewsCount}}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col d-flex mt-2"  v-if="userType !== 'InternalUser'" id="people" @mouseover ="mouseover_home" @mouseout="mouseleave_home" @click="routetoPeople()" :class="{'active': ( currentRoute === 'MainHome')}">
                    <div class="pl-1 mt-sm-3 mt-md-3 mt-lg-4 d-flex"  >
                      <!-- <router-link to="/people" tag="a"> -->
                        <img :src="homeSvg" class="img-fluid mr-2 " alt="home" id="icon-img" />
                        <!-- <label class="bold ml-2 p-1 proximanova fontsize16 black listitemname">Home</label> -->
                        <div class="listitemname">
                          <label class="bold ml-2 p-1 proximanova fontsize16  pointer">Home</label>
                        </div>
                      <!-- </router-link> -->
                    </div>
                  </div>
                  <div class="col d-flex mt-2"  v-if="userType == 'InternalUser'" id="people" @mouseover ="mouseover_home" @mouseout="mouseleave_home" @click="routeToCourseVideos()" :class="{'active': ( currentRoute === 'coursevideos')}">
                    <div class="pl-1 mt-sm-3 mt-md-3 mt-lg-4 d-flex"  >
                      <!-- <router-link to="/people" tag="a"> -->
                        <img :src="homeblueSvg" class="img-fluid mr-2 " alt="home" id="icon-img" />
                        <!-- <label class="bold ml-2 p-1 proximanova fontsize16 black listitemname">Home</label> -->
                        <div class="listitemname">
                          <label class="bold ml-2 p-1 proximanova fontsize16  pointer">Course Videos</label>
                        </div>
                      <!-- </router-link> -->
                    </div>
                  </div>
                  <div class="col d-flex"  v-if="userType !== 'InternalUser'" id="people" :class="{'active': ( currentRoute === 'People')}" @mouseover ="mouseover" @mouseout="mouseleave" @click="routetosuggestedpage('suggested')">
                    <div class="pl-1 mt-sm-3 mt-md-3 mt-lg-4 d-flex" >                     
                        <img :src="peopleSvg" class="img-fluid mr-2 " alt="people" id="icon-img" />
                        <!-- <label class="bold ml-2 p-1 proximanova fontsize16 black listitemname">People</label> -->
                        <div class="listitemname">
                          <label class="bold ml-2 p-1 proximanova fontsize16  pointer">People</label>
                        </div>                   
                    </div>
                  </div>
                  <hr class="profhoriz"  v-if="userType !== 'InternalUser'">
                  <div class="col d-flex"  v-if="userType !== 'InternalUser'" id="people" :class="{'active': currentRoute === 'job'}"  @mouseover ="mouseover_job" @mouseout="mouseleave_job" @click="routetoJobpage()">
                    <div class="pl-1 mt-sm-3 mt-md-3 mt-lg-4 d-flex" >
                      <!-- <router-link to="/people" tag="a"> -->
                        <img :src="jobSvg" class="img-fluid mr-2" alt="jobs" id="icon-img"/>
                        <div class="listitemname">
                          <label class="bold ml-2 p-1 proximanova fontsize16 pointer ">Jobs</label>
                        </div>
                      <!-- </router-link> -->
                    </div>
                  </div>
                  <div class="col d-flex"  v-if="userType !== 'InternalUser'" id="people" :class="{'active': currentRoute === 'track'}" @mouseover ="mouseover_track" @mouseout="mouseleave_track" @click="routetoTrackpage()">
                    <div class="pl-1 mt-sm-3 mt-md-3 mt-lg-4 d-flex" >
                      <!-- <router-link to="/people" tag="a"> -->
                        <img :src="trackSvg" class="img-fluid mr-2" alt="jobs" id="icon-img"/>
                        <div class="listitemname">
                          <label class="bold ml-2 p-1 proximanova fontsize16 pointer ">Track Application</label>
                        </div>
                      <!-- </router-link> -->
                    </div>
                  </div>
                  <div class="col d-flex"  v-if="userType !== 'InternalUser'" id="people" :class="{'active': currentRoute === 'interestedinyou'}" @mouseover ="mouseover_interested" @mouseout="mouseleave_interested" @click="routetoInterested()">
                    <div class="pl-1 mt-sm-3 mt-md-3 mt-lg-4 d-flex" >
                      <!-- <router-link to="/people" tag="a"> -->
                        <img :src="interestedSvg" class="img-fluid mr-2" alt="jobs" id="icon-img"/>
                        <div class="listitemname">
                          <label class="bold ml-2 p-1 proximanova fontsize16 pointer ">Recruiter Requests</label>
                        </div>
                      <!-- </router-link> -->
                    </div>
                  </div>
                  <hr class="profhoriz"  v-if="userType !== 'InternalUser'">
                  <div class="col d-flex"  v-if="userType !== 'InternalUser'" id="people" :class="{'active': currentRoute === 'referandearn'}" @mouseover ="mouseover_refer" @mouseout="mouseleave_refer" @click="routetoRefer()">
                    <div class="pl-1 mt-sm-3 mt-md-3 mt-lg-4 d-flex" >
                      <!-- <router-link to="/people" tag="a"> -->
                        <img :src="referSvg" class="img-fluid mr-2" alt="jobs" id="icon-img"/>
                        <div class="listitemname">
                          <label class="bold ml-2 p-1 proximanova fontsize16 pointer ">Invite Friends</label>
                        </div>
                      <!-- </router-link> -->
                    </div>
                  </div>
                  <div class="col d-lg-none mt-2 ml-1"  v-if="userType !== 'InternalUser'">
                    <div class="jobSec">
                      <div class="card-body">
                        <div class="row no-gutters">
                          <div class="col font14 proximanova fontsize16 black">Looking for a job change</div>
                          <div class="custom-control custom-switch">
                            <input
                              type="checkbox"
                              v-model="jobchange"
                              class="custom-control-input"
                              id="switch1"
                              name="example"
                            />
                            <label class="custom-control-label" for="switch1"></label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col d-lg-none d-sm-block d-md-block" v-if="userType !== 'InternalUser'">
                    <div v-if="this.showpending != false" class="ml-1 mt-2 mr-5 pendingSec">
                      <div class="card-body pending">
                        <div class="row no-gutters">
                          <div class="col">
                            <label class="proximanova-semibold fontsize12 black60 ml-3">Pending Activities</label>
                            <img
                              src="../assets/Close.svg"
                              class="img-fluid float-right mt-1 mr-2"
                              alt="close"
                              @click="pending()"
                            />
                          </div>
                        </div>
                        <div class="row no-gutters">
                          <div id="demo" class="carousel slide">
                            <div class="carousel-inner">
                              <div class="carousel-item item1 active card p-0" v-if="!currenteUser.resumeVideoId">
                                <div
                                  class="d-flex flex-column text-center rounded-top slide-background pt-1 pl-2 pr-2 pb-2"
                                >
                                  <img
                                    src="../assets/VideoResume.svg"
                                    alt="videoresume"
                                    class="img-fluid mb-1 mr-2 carousel-img"
                                  />
                                  <label class="proximanova fontsize12 black80">Video Resume</label>
                                  <span
                                    class="font10-opacity30 mt-0"
                                  >it increases your profile strength</span>
                                </div>
                                <div class="text-center pendingmouseover p-1" @click="VideoResumeModalOpen">
                                  <span class="proximanova-semibold light-red fontsize12">create</span>
                                </div>
                              </div>
                              <div class="carousel-item item1 card p-0" v-if="!currenteUser.profileVideoId">
                                <div
                                  class="d-flex flex-column text-center rounded-top slide-background pt-1 pl-2 pr-2 pb-2"
                                >
                                  <img src="../assets/VideoResume.svg" class="img-fluid mb-1 mr-2 carousel-img" alt="videoresume" />
                                  <label class="proximanova fontsize12 black80">Video Profile</label>
                                  <span class="font10-opacity30 mt-0">it increases your profile strength</span>
                                </div>
                                <div class="text-center pendingmouseover p-1" @click="VideoProfileModalOpen">
                                  <span class="">create</span>
                                </div>
                              </div>
                              <div class="carousel-item item1 card p-0" v-if="!currenteUser.profileId">
                                <div
                                  class="d-flex flex-column text-center rounded-top slide-background pt-1 pl-2 pr-2 pb-2"
                                >
                                  <img src="../assets/ProfileDetails.svg" class="img-fluid mb-1 mr-2 carousel-img" alt="profileinfo"/>
                                  <label class="proximanova fontsize12 black80">Profile Details</label>
                                  <span class="font10-opacity30 mt-0">it increases your profile strength</span>
                                </div>
                                <div class="text-center pendingmouseover p-1">
                                  <span class="proximanova-semibold light-red fontsize12" @click="createProfileDetails">create</span>
                                </div>
                              </div>
                            </div>
                            <a class="carousel-control-prev align-left" href="#demo" data-slide="prev" @click="ChangeCurrentSlide('prev')">
                              <img src="../assets/PrevArrow.svg" style="color:black" alt="backarrow"/>
                            </a>
                            <a class="carousel-control-next align-right" href="#demo" data-slide="next" @click="ChangeCurrentSlide('next')">
                              <img src="../assets/NextArrow.svg" style="color:black" alt="arrow"/>
                            </a>
                          </div>
                        </div>
                        <div class="column pdtext">
                          <div class="row mb-1">
                            <div class="hr-theme-slash-2 col-12">
                              <div class="hr-line"></div>
                              <div class="hr-icon col-4 rounded-circle pt-1">{{currentIndex}} of {{totalIndex}}</div>
                              <div class="hr-line"></div>
                            </div>
                          </div>
                          <span class="text-center ">
                            Your Profile strength is
                            <strong>{{profilestrengthLabel}}</strong>,
                            complete your pending activities to keep your
                            profile strong
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <profileresumemodal v-if="profileresumemodalopenside" :profileresume="profileresumeobj" @close = "closeModal"></profileresumemodal>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
    <no-profile-id-modal-component v-if="displayNoProfileModalComponent" @closeNoProfileIdModal="closeNoProfileIdModal"></no-profile-id-modal-component>
  </div>
</template>
<script>
import menus from "@/components/Menu.vue";
import Topmenus from "@/components/TopHeader.vue";
import profile from "@/components/ProfileCreation.vue";
import profilehome from "@/components/ProfileHome.vue";
import BottomFooter from "@/components/BottomFooter.vue";
import editprofile from "@/components/EditProfile.vue";
import person from "../assets/person.png";
import vselect from "@/css/vselect.css";
import httpuserprofile from "@/js/http-userprofile.js";
import { bus } from "../main";
// import util from "../js/common-utils.js";
import profileresumemodal from '@/components/profileResumeModal.vue'
import NoProfileIdModalComponent from '@/components/NoprofileIdModal.vue'
import router from '../router';
import sessionUtils from '@/js/session-util.js'
import commonUtils from '@/js/common-utils.js'
export default {
  components: {
    menus,
    Topmenus,
    BottomFooter,
    profile,
    profilehome,
    NoProfileIdModalComponent,
    editprofile
  },

  data() {
    return {
      userType : null,
      getuserid: "",
      email: "",
      userdatalist: [],
      profileUserId: "",
      profileId: "",
      profilePictureLink : '',
      profileVideoId : '',
      firstName : '',
      lastName :'',
      fullName : '',
      getuseraliasname : null,
      designation : '',
      showpending: true,
      profileobject: {
        profile: false,
        profilehome: false,
        editprofile: false,
        profilecreation: "home",
        profilevalue: "",
        home: "home",
        getalldata: [],
        recruiterprofile: false,
        test: "",
        imagefile: person,
        id: ""
      },
      currentRoute : '',
      selectElement: '',
      jobchange: false,
      peopleSvg: null,
      jobSvg: require('../assets/Job.svg'),
      trackSvg: require('../assets/Tracking.svg'),
      referSvg : require('../assets/refer_sidemenu_black.svg'),
      interestedSvg : require('../assets/interested.svg'),
      homeSvg: null,
      homeblueSvg : require('../assets/Homeblue.svg'),
      profileresumeobj : {},
      profileresumemodalopenside : false,
      currenteUser : [],
      profilestrengthLabel : 'Very Low',
      totalIndex : null,
      currentIndex : 1,
      profileViewsCount : 0,
      videoProfileviewsCount : 0,
      TotalVideosviewsCount : 0,
      displayNoProfileModalComponent : false,
    };
  },
  components: {
    profileresumemodal
  },
  methods: {
    ErrorwithProfilePic() {
      this.profilePictureLink = null;
    },
    closeNoProfileIdModal(){
      this.displayNoProfileModalComponent = false;
    },
    fetchdata() {
      this.getUserById()      
    },
    //display pending activities cards for small and medium devices
    // using these three events to post a profile /resume video or close modal
    VideoResumeModalOpen : function() {
      if(this.profileId){
      this.profileresumemodalopenside = true;
      this.profileresumeobj.videoType = "resumevid"
      }else{
        this.displayNoProfileModalComponent = true;
      }
    },
    VideoProfileModalOpen : function() {
      if(this.profileId){
      this.profileresumemodalopenside = true;
      this.profileresumeobj.videoType = "profilevid"
      }else{
        this.displayNoProfileModalComponent = true;
      }
    },
    closeModal() {
      this.profileresumemodalopenside = false;
    },
    // this will invoke after click on logo 
    // navigate user to welcome page / home feed page
    // close sidemenu after navigation in small/medium devices
    gotoMainPage(){
      commonUtils.scorlltop()
      if(!this.profileId){
         this.$router.push({
          name : 'welcome'
        })
      }else{
        sessionUtils.setSelectedElement('home')
       this.$router.push({
          name : 'MainHome'
        })
      } 
      if(screen.width < 900) {
        let backbtn = document.getElementById('hamburgerbackbtnclick')
        if(backbtn) {
          backbtn.click()
        }    
      }
    },
    // this will invoke after click on home sidemenu option
    // navigate user to home feed page
    // close sidemenu after navigation in small/medium devices
    routetoPeople(){   
      commonUtils.scorlltop()   
      sessionUtils.setSelectedElement('home')
       this.$router.push({
          name : 'MainHome'
        })
      if(screen.width < 900) {
        let backbtn = document.getElementById('hamburgerbackbtnclick')
        if(backbtn) {
          backbtn.click()
        }    
      }
    },
    // this will invoke after click on job sidemenu option 
    // navigate user to job page
    // close sidemenu after navigation in small/medium devices
    routetoJobpage : function() {
      commonUtils.scorlltop()
      sessionUtils.setSelectedElement('job')
       router.push({
        name : 'job'
      })
      bus.$emit('refreshDatawhenInSameJobPage', true)
      if(screen.width < 900) {
        let backbtn = document.getElementById('hamburgerbackbtnclick')
        if(backbtn) {
          backbtn.click()
        }    
      }
    },
    // this will invoke after click on profile view count to naviagte to the profile views page
    // close sidemenu after navigation in small/medium devices
    navToProfileViews : function() {
      sessionUtils.setProfileViewsActiveTab('Profile')
      router.push({
        name : 'profileViews'
      })
      bus.$emit('openProfileViewsTab', 'Profile')
      if(screen.width < 900) {
        let backbtn = document.getElementById('hamburgerbackbtnclick')
        if(backbtn) {
          backbtn.click()
        }    
      }
    },
    // this will invoke after click on profile video views count to naviagte to the profile video views page
    // close sidemenu after navigation in small/medium devices
    navToProfileVideoViews : function() {
      sessionUtils.setProfileViewsActiveTab('Video_Profile')
      router.push({
        name : 'profileViews'
      })
      bus.$emit('openProfileViewsTab', 'Video_Profile')
      if(screen.width < 900) {
        let backbtn = document.getElementById('hamburgerbackbtnclick')
        if(backbtn) {
          backbtn.click()
        }    
      }
    },
    // this will invoke after click on people sidemenu option 
    // navigate user to welcome suggested people page
    // close sidemenu after navigation in small/medium devices
    routetosuggestedpage:function(element){
      // if(this.profileId !== null & this.profileId !== undefined) {
        // sessionStorage.setItem('activeElement', elementname)
        commonUtils.scorlltop()
        sessionUtils.setPeopleActiveTab('suggested')
        // this.$session.set("activeElement", element)
        this.$router.push({
          name : 'People'
        })
      // }
      bus.$emit('refreshDatawhenInSamePeoplePage', true)
      if(screen.width < 900) {
        let backbtn = document.getElementById('hamburgerbackbtnclick')
        if(backbtn) {
          backbtn.click()
        }    
      }
    },
    routeToCourseVideos() {
      this.$router.push({
          name : 'coursevideos'
        })
    },
    //fetching user details
    getUserById : function(){
      var that = this
      httpuserprofile.get('/userprofile/userbyid/'+
      sessionUtils.getUserId()).then(response =>{
          this.profileId = response.data.profileId;
          this.profilePictureLink = response.data.profilePictureLink;
          this.profileVideoId = response.data.profileVideoId
          this.firstName = response.data.firstName;
          this.lastName = response.data.lastName;
          this.getuseraliasname = response.data.aliasName;
          sessionUtils.setUserAliasName(this.getuseraliasname)
          this.fullName = this.firstName +' '+this.lastName
          this.currenteUser = response.data;        
          if(response.data.designation){
            this.designation = response.data.designation.roleName
          }
          if(this.currenteUser.profileId && this.currenteUser.resumeVideoId){
            this.showpending = false;
          }
          that.$store.state.profilePicLink = response.data.profilePictureLink;
          sessionUtils.setUserProfileId(this.profileId)
          this.setCount()
          if(this.profileId){
          this.getWhoViewedCount()
          }
        }
      )
    },
    setCount() {
      var that = this;
      setInterval(function(){ 
        let x = document.getElementsByClassName('item1')
        that.totalIndex = x.length
      }, 1000)
    },
    //fetching views count
    getWhoViewedCount : function() {
      if(this.profileVideoId == null) {
        this.profileVideoId = ''
      }
      httpuserprofile.get('/userprofile/recordsCount?profileId='+this.profileId+'&videoprofileId='+this.profileId)
      .then((response) => {
        console.log("count of who viewed my : ", response)
        this.profileViewsCount = response.data.totalProfileViewers;
        if(response.data.totalVideoViewers !== null) {
          this.videoProfileviewsCount = response.data.totalVideoViewers
        }else{
          this.videoProfileviewsCount = 0
        }
        
      }).catch((e) => {
        console.log(e)
      })
    },
    ChangeCurrentSlide : function(slide) {
      if(this.totalIndex == 1){
        this.currentIndex = 1
        return
      }
      if(this.totalIndex == 2) {
        if(this.currentIndex == 1) {
          this.currentIndex = 2
          return
        }else{
          this.currentIndex = 1
          return
        }
      }
      if(slide === 'prev'){
        if(this.totalIndex == 3){
          if(this.currentIndex === 1){
            this.currentIndex = 3
            return
          }
          if(this.currentIndex === 2){
            this.currentIndex = 1
            return
          }
          if(this.currentIndex === 3){
            this.currentIndex = 2
            return
          }
        }
      }
      if(slide === 'next'){
        if(this.totalIndex == 3){
          if(this.currentIndex === 1){
            this.currentIndex = 2;
            return
          }
          if(this.currentIndex === 2){
            this.currentIndex = 3
            return
          }
          if(this.currentIndex === 3){
            this.currentIndex = 1
            return
          }
        }
      }
    },
    //mouser/mouseleave events on sidmenu events
    mouseover: function(){      
      this.peopleSvg = require('../assets/Peopleblue.svg')
    },
    mouseleave: function(){
      // console.log(this.currentRoute)
      if(this.currentRoute !== 'People'){
        this.peopleSvg = require('../assets/People.svg');
      }
      
    },
    mouseover_job: function(){      
      this.jobSvg = require('../assets/Jobblue.svg')
    },
    mouseleave_job: function(){
      if(this.currentRoute !== 'job'){
      this.jobSvg = require('../assets/Job.svg')
      }
      
    },
    mouseover_home: function(){
      this.homeSvg = require('../assets/Homeblue.svg')
    },
    mouseleave_home: function(){
      // console.log(this.currentRoute)
      if(this.currentRoute !== 'MainHome'){
      this.homeSvg = require('../assets/Home.svg')
      }
    },
    mouseover_track: function(){      
      this.trackSvg = require('../assets/TrackBlue.svg')
    },
    mouseleave_track: function(){
      if(this.currentRoute !== 'track'){
        this.trackSvg = require('../assets/Tracking.svg')
      }
    },
    mouseover_interested: function(){      
      this.interestedSvg = require('../assets/interested_blue.svg')
    },
    mouseleave_interested: function(){
      if(this.currentRoute !== 'interestedinyou'){
        this.interestedSvg = require('../assets/interested.svg')
      }
    },
    mouseover_refer: function() {
      this.referSvg = require('../assets/refer_sidemenu_blue.svg')
    },
    mouseleave_refer: function() {
      if(this.currentRoute !== 'referandearn'){
        this.referSvg = require('../assets/refer_sidemenu_black.svg')
      }
    },
    createProfileDetails: function() {
      this.$router.push({
        name : 'createprofile'
      })
    },
    pending() {
      this.showpending = false;
    },
    openMainPage(){
      if(this.userType !== 'InternalUser') {
        if(this.profileId) {
        this.$store.state.selectedUser = this.getuseraliasname; 
        this.$router.push({name: 'wn', params: { id: this.$store.state.selectedUser}});
        bus.$emit('refershDataWhenInUserProfilePage', this.getuseraliasname)
        }else{
        this.$router.push({
          name : 'welcome'
        })
        }
      if(screen.width < 900) {
        let backbtn = document.getElementById('hamburgerbackbtnclick')
        if(backbtn) {
          backbtn.click()
        }    
      }
      }
    },
    // homepage: function() {
    //   //make a rest call to capture a logout for the user
    //   this.$session.clear();
    //   this.$session.destroy();

    //   this.$router.push("/");
    // },
    // openNav() {
    //   document.getElementById("mySidenav").style.width = "250px";
    //   document.getElementById("main").style.marginLeft = "250px";
    // },

    // closeNav() {
    //   document.getElementById("mySidenav").style.width = "0";
    //   document.getElementById("main").style.marginLeft = "0";
    // },

    // loadFile: function() {
    //   var image = document.getElementById("file").value;

    //   this.profileobject.imagefile = URL.createObjectURL(event.target.files[0]);
    // },
    // enablerecruiter: function() {
    //   this.recruiterprofile = false;
    // },

    // profilepage() {
    //   document.getElementById("main").style.marginLeft = "0";

    //   if (parseInt(this.$session.get("user_id")) == parseInt(this.getuserid)) {
    //     console.log("edit");

    //     this.$session.start();
    //     this.$session.set("profileId", this.profileId);
    //     this.profileobject.profilehome = false;
    //     this.profileobject.profile = false;
    //     this.profileobject.editprofile = true;
    //     document.getElementById("mySidenav").style.width = "0px";
    //   } else if (
    //     parseInt(this.$session.get("user_id")) !== parseInt(this.getuserid)
    //   ) {
    //     console.log("create");
    //     this.profileobject.profilevalue = "profile";
    //     this.profileobject.profilehome = true;
    //     this.profileobject.editprofile = false;
    //     this.profileobject.profile = false;
    //     document.getElementById("mySidenav").style.width = "0px";
    //   }
    // },
    // this will invoke after click on track applicatios sidemenu option 
    // navigate user to track applications feed page
    // close sidemenu after navigation in small/medium devices
    routetoTrackpage: function(){
      commonUtils.scorlltop()
      sessionUtils.setSelectedElement("track")
      this.$router.push({
          name : 'track'
        })
      bus.$emit('refreshDatawhenInSameTrackPage', true)
      if(screen.width < 900) {
        let backbtn = document.getElementById('hamburgerbackbtnclick')
        if(backbtn) {
          backbtn.click()
        }    
      }
    },
    routetoInterested:function() {
      commonUtils.scorlltop()
      sessionUtils.setSelectedElement("interestedinyou")
      this.$router.push({
          name : 'interestedinyou'
        })
      if(screen.width < 900) {
        let backbtn = document.getElementById('hamburgerbackbtnclick')
        if(backbtn) {
          backbtn.click()
        }    
      }
    },
    routetoRefer: function(){
      commonUtils.scorlltop()
      sessionUtils.setSelectedElement("referandearn")
      this.$router.push({
          name : 'referandearn'
        })
      if(screen.width < 900) {
        let backbtn = document.getElementById('hamburgerbackbtnclick')
        if(backbtn) {
          backbtn.click()
        }    
      }
    },
    getallprofiledata() {
      httpuserprofile.get("/userprofile/readProfiles").then(response => {
        for (var i = 0; i < response.data.length; i++) {
          this.getalldata = response.data[i];
          console.log(JSON.stringify(this.getalldata));
          if (sessionUtils.getUserId() == this.getalldata.userId) {
            this.profileId = this.getalldata.profileId;
            this.getprofiledata();
          }
        }
      });
    },
    getprofiledata() {
      httpuserprofile
        .get("/userprofile/userbyid/" + this.profileId)
        .then(response => {
          this.userdatalist = response.data;
          this.email = this.userdatalist.email;
          this.getuserid = this.userdatalist.userId;
          /* for(var i=0; i< response.data.length;i++){
    this.userdatalist = response.data[i]
   this.email = userdatalist.email
   this.profileUserId=userdatalist.userId
    console.log( this.email)
     }

   console.log(JSON.stringify(response.data.email))*/
        });
    },

    profilehomepage() {
      this.profileobject.profilehome = false;
      this.profileobject.profile = false;
      this.profileobject.editprofile = false;

      document.getElementById("mySidenav").style.width = "0px";
      document.getElementById("main").style.marginLeft = "0";
      this.profileobject.profilecreation = "home";
    },
    sidenav() {
      // // let mainNavLinks = document.querySelectorAll("nav ul li a");
      // // let lastId;
      // // let cur = [];
      // // window.addEventListener("scroll", event => {
      // //   let fromTop = window.scrollY;
      // //   mainNavLinks.forEach(link => {
      // //     let section = document.querySelector(link.hash);
      // //     if (
      // //       section.offsetTop <= fromTop &&
      // //       section.offsetTop + section.offsetHeight > fromTop
      // //     ) {
      // //       link.classList.add("current");
      // //     } else {
      // //       link.classList.remove("current");
      // //     }
      // //   });
      // });
    }
  },
  //watchers to set the active sidemenu option
 watch: {
   '$route': function (from, to) {
      this.currentRoute = this.$router.currentRoute.name;     
    this.selectElement = sessionUtils.getSelectedElement()
    // console.log(this.currentRoute,this.selectElement)
    if(this.currentRoute === 'MainHome'){      
      this.homeSvg = require('../assets/Homeblue.svg');
      this.peopleSvg =require('../assets/People.svg');
      this.jobSvg = require('../assets/Job.svg')  
      this.trackSvg = require('../assets/Tracking.svg')  
      this.referSvg = require('../assets/refer_sidemenu_black.svg')
      this.interestedSvg = require('../assets/interested.svg') 
    }else if( this.currentRoute === 'People'){
      this.homeSvg = require('../assets/Home.svg');
      this.peopleSvg =require('../assets/Peopleblue.svg');
      this.jobSvg = require('../assets/Job.svg')  
      this.trackSvg = require('../assets/Tracking.svg')  
      this.referSvg = require('../assets/refer_sidemenu_black.svg')
      this.interestedSvg = require('../assets/interested.svg') 
    }else if( this.currentRoute === 'job'){
      this.homeSvg = require('../assets/Home.svg');
      this.peopleSvg =require('../assets/People.svg');
      this.jobSvg = require('../assets/Jobblue.svg')
      this.trackSvg = require('../assets/Tracking.svg')  
      this.referSvg = require('../assets/refer_sidemenu_black.svg')
      this.interestedSvg = require('../assets/interested.svg') 
    }else if( this.currentRoute === 'track'){
      // console.log('enter')
      this.homeSvg = require('../assets/Home.svg');
      this.peopleSvg =require('../assets/People.svg');
      this.jobSvg = require('../assets/Job.svg')  
      this.trackSvg = require('../assets/TrackBlue.svg')  
      this.referSvg = require('../assets/refer_sidemenu_black.svg')
      this.interestedSvg = require('../assets/interested.svg') 
    }else if( this.currentRoute === 'interestedinyou'){
      console.log('enter interset')
      this.homeSvg = require('../assets/Home.svg');
      this.peopleSvg =require('../assets/People.svg');
      this.jobSvg = require('../assets/Job.svg')  
      this.trackSvg = require('../assets/Tracking.svg')  
      this.referSvg = require('../assets/refer_sidemenu_black.svg')
      this.interestedSvg = require('../assets/interested_blue.svg') 
    }else if(this.currentRoute === 'referandearn'){
      this.homeSvg = require('../assets/Home.svg');
      this.peopleSvg =require('../assets/People.svg');
      this.jobSvg = require('../assets/Job.svg')  
      this.trackSvg = require('../assets/Tracking.svg')  
      this.referSvg = require('../assets/refer_sidemenu_blue.svg')
      this.interestedSvg = require('../assets/interested.svg') 
    }
    else{
      this.homeSvg = require('../assets/Home.svg');
      this.peopleSvg =require('../assets/People.svg');
      this.jobSvg = require('../assets/Job.svg')
      this.trackSvg = require('../assets/Tracking.svg') 
      this.referSvg = require('../assets/refer_sidemenu_black.svg') 
      this.interestedSvg = require('../assets/interested.svg') 
    }
    if(this.currentRoute !== 'MainHome' && this.currentRoute !== 'People' && this.currentRoute !== 'job' &&  this.currentRoute !== 'track' && this.currentRoute !== 'referandearn'&& this.currentRoute !== 'interestedinyou'){
       this.homeSvg = require('../assets/Home.svg');
       this.peopleSvg =require('../assets/People.svg');
       this.jobSvg = require('../assets/Job.svg')  
      this.trackSvg = require('../assets/Tracking.svg');  
      this.referSvg = require('../assets/refer_sidemenu_black.svg')
      this.interestedSvg = require('../assets/interested.svg') 
       this.selectElement = '';
    }
    if(this.selectElement === undefined){
       this.peopleSvg =require('../assets/People.svg');
       this.homeSvg = require('../assets/Home.svg');
        this.jobSvg = require('../assets/Job.svg');
        this.trackSvg = require('../assets/Tracking.svg'); 
        this.referSvg = require('../assets/refer_sidemenu_black.svg') 
        this.interestedSvg = require('../assets/interested.svg') 
    }
   }
 },
  
  created() {    
    this.currentRoute = this.$router.currentRoute.name;
    this.selectElement = sessionUtils.getSelectedElement()
    // this.userType = localStorage.getItem("userType");
    // console.log(that.currentRoute,that.selectElement)
      if(this.currentRoute === 'MainHome'){      
      this.homeSvg = require('../assets/Homeblue.svg');
      this.peopleSvg =require('../assets/People.svg');
      this.jobSvg = require('../assets/Job.svg');
      this.trackSvg = require('../assets/Tracking.svg') 
      this.referSvg = require('../assets/refer_sidemenu_black.svg')
      this.interestedSvg = require('../assets/interested.svg') 
    }else if(this.currentRoute === 'People'){
      this.homeSvg = require('../assets/Home.svg');
      this.peopleSvg =require('../assets/Peopleblue.svg');
      this.jobSvg = require('../assets/Job.svg');
        this.trackSvg = require('../assets/Tracking.svg') 
        this.referSvg = require('../assets/refer_sidemenu_black.svg')
        this.interestedSvg = require('../assets/interested.svg') 
    }else if( this.currentRoute === 'job'){
      this.homeSvg = require('../assets/Home.svg');
      this.peopleSvg =require('../assets/People.svg');
      this.jobSvg = require('../assets/Jobblue.svg')
      this.trackSvg = require('../assets/Tracking.svg') 
      this.referSvg = require('../assets/refer_sidemenu_black.svg')
      this.interestedSvg = require('../assets/interested.svg') 
    }else if(this.currentRoute === 'track'){
      // console.log('enter')
      this.homeSvg = require('../assets/Home.svg');
      this.peopleSvg =require('../assets/People.svg');
      this.jobSvg = require('../assets/Job.svg')  
      this.trackSvg = require('../assets/TrackBlue.svg') 
      this.referSvg = require('../assets/refer_sidemenu_black.svg')
      this.interestedSvg = require('../assets/interested.svg') 
    }else if( this.currentRoute === 'interestedinyou'){
      // console.log('enter')
      this.homeSvg = require('../assets/Home.svg');
      this.peopleSvg =require('../assets/People.svg');
      this.jobSvg = require('../assets/Job.svg')  
      this.trackSvg = require('../assets/Tracking.svg')  
      this.referSvg = require('../assets/refer_sidemenu_black.svg')
      this.interestedSvg = require('../assets/interested_blue.svg') 
    }else if(this.currentRoute === 'referandearn'){
      this.homeSvg = require('../assets/Home.svg');
      this.peopleSvg =require('../assets/People.svg');
      this.jobSvg = require('../assets/Job.svg')  
      this.trackSvg = require('../assets/Tracking.svg')  
      this.referSvg = require('../assets/refer_sidemenu_blue.svg')
      this.interestedSvg = require('../assets/interested.svg') 
    }else{
      this.homeSvg = require('../assets/Home.svg');
      this.peopleSvg =require('../assets/People.svg');
      this.jobSvg = require('../assets/Job.svg')
      this.trackSvg = require('../assets/Tracking.svg') 
      this.referSvg = require('../assets/refer_sidemenu_black.svg')
      this.interestedSvg = require('../assets/interested.svg') 
    }
    var that = this;
    
    setInterval(function(){ 
      that.profilestrengthLabel = that.$store.state.profileStrength;
      // that.profilePictureLink  = that.$store.state.profilePicLink;
    }, 1000)
    if(this.currentRoute !== 'MainHome' && this.currentRoute !== 'People' ){
       this.homeSvg = require('../assets/Home.svg');
       this.peopleSvg =require('../assets/People.svg');
       this.selectElement = '';
    }
    if(this.selectElement === undefined){
       this.peopleSvg =require('../assets/People.svg');
       this.homeSvg = require('../assets/Home.svg');
    }
      this.fetchdata();    
    bus.$on('updatingProfilePictureLink', (data) => {
      if(data){
        this.profilePictureLink = data;
      }
    })
    bus.$on('updateProfileInformation', (data) => {
      if(data){
        this.fetchdata()
      }
    })
    bus.$on('clearProfileVideoViewsInSidemenu', (data) => {
      if(data) {
        this.videoProfileviewsCount = 0;
      }
    })
  }, 
};
</script>
<style scoped>
.navbar {
  padding: 0px 0px 0px 0px !important;
  position: fixed;
  background-color: #ffffff;
  z-index: 1;
}
.sidebar-backgroundheader {
  background-color: #ffffff;
}
.loadingBgImg{
  background: transparent url('../assets/loading_gif1.gif') center no-repeat;
  background-size: 30px 30px;
}
#profImage{
  width: 42px;
  height: 42px;
}
/* .navbar-collapse {
        position: fixed;
        top: 0px;
        left: 0; */
/* padding-left: 15px; */
/* padding-right: 15px;
        padding-bottom: 15px;
        width: 62%;
        height: 100%;
    }

    .navbar-collapse.collapsing {
        left: -75%;
        transition: height 0s ease;
    }

    .navbar-collapse.show {
        left: 0;
        transition: left 300ms ease-in-out;
    }

    .navbar-toggler.collapsed ~ .navbar-collapse {
        transition: left 500ms ease-in-out;
    } */
.carousel-control-next,
.carousel-control-prev {
  filter: invert(50%);
}
.navbar{
  z-index: 100;
}
.carousel-inner {
  /* width: 325px; */
  width: 100%;
  padding: .5em 3em;
}
.carousel-item {
  padding: 20%;
}
.carousel-img {
  width: 30px;
  margin-left: 40%;
}
/* .closemenuicon{
  width: 50px;
} */
.slide-background {
  background-color: #f3f4f7;
}
.pendingmouseover {
  color: #fc597f;
  font-family: "Proxima Nova";
  font-size: 16px;
  font-weight: 300;
  cursor: pointer;
  background-color: white;
}
.pendingmouseover:hover{
  /* opacity: 1;
  background: -webkit-linear-gradient(44.51deg, #E6784F 0%, #EA5184 100%);
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
  border: 2px solid transparent;
  border-radius: 10px !important;
  -moz-border-image: -moz-linear-gradient(top, #E6784F 0%, #EA5184 100%);
  -webkit-border-image: -webkit-linear-gradient(top, #E6784F 0%, #EA5184 100%);
  border-image: linear-gradient(to bottom, #E6784F 0%, #EA5184 100%);
  border-image-slice: 1; */
  opacity: 1 !important;
  background: -webkit-linear-gradient(44.51deg, #E6784F 0%, #EA5184 100%);  
  background: -moz-linear-gradient(44.51deg, #E6784F 0%, #EA5184 100%);  
  background: -o-linear-gradient(44.51deg, #E6784F 0%, #EA5184 100%);  
  background: linear-gradient(44.51deg, #E6784F 0%, #EA5184 100%);  
  border-radius: 5px;
	/* opacity: 90% !important; */
	color: #FFFFFF !important;
  /* -webkit-text-fill-color: transparent; */
}
.profilesummery {
  background-color: rgba(161, 166, 179,0.06);
  border-radius: 10px;
  /* width: 250px; */
}
.profiledet {
  padding-left: 0px;
  padding-right: 10px;
}
.profhoriz {
  margin-top: .25em;
  margin-bottom: .25em;
  margin-left: 15px;
  margin-right: 15px;
  border-top: 1.5px solid rgba(0,0,0,.1)
}
.viewhover:hover {
  cursor: pointer;
  /* color: blue; */
  text-decoration: underline;
}
/* .proximanova-semibold light-red fontsize12 {
  color: #fc597f;
  font-family: "Proxima Nova";
  font-size: 16px;
  font-weight: 300;
  cursor: pointer;
} */
.profile-border{
  padding: 1.5px;
  border: 2px solid #ced4da;
  border-radius: 50%;
}
.pdtext {
  font-size: 12px;
  padding: 0 1em 1em 0;
  text-align: center;
}
.jobSec {
  width: 365px;
}
.listitemname {
  margin-top: -4px;
}
#icon-img{
  width: 20px;
  height: 20px;
}
.pending {
  padding: 0 1em  !important;
}
.active{
  /* border: 2px solid #007AFF;  
  background-color: #d6e9ff  !important; */
  background-color: rgba(161, 166, 179,0.06);
   color: #007AFF !important;
   cursor: pointer;
}
#people:hover{
   background-color: rgba(161, 166, 179,0.06);
   color: #007AFF !important;
   cursor: pointer;
}

#people:active{
  border: 2px solid #007AFF;  
  background-color: #d6e9ff;
  border-radius: 10px;
}
a {
  color:black;
}
#people a:hover{
  color: blue
}
.profhoriz {
  margin-top: .25em;
  margin-bottom: .25em;
  margin-left: 15px;
  margin-right: 15px;
  border-top: 1.5px solid rgba(0,0,0,.1)
}
.hover{
  cursor: pointer;
}
#nameBlock:hover{
color:#007AFF;
white-space: nowrap;
}
  .fullName{
    white-space: nowrap;
  }
  #people::before {
	transition : 0.5s all ease;
	position : absolute;
	top : 0;
	left : 30%;
	right : 30%;
	bottom : 0;
	opacity : 0;
	content : "";
  border-radius: 20px;
	background-color :  rgba(161, 166, 179,0.06);
  
  }
 
  #people:hover:before {
	transition : 0.5s all ease;
	left : 0;
	right : 0;
	opacity : 1;
	z-index : -1;
  border-radius: 10px;
  border: 1px solid red;
  }
.pendingSec,
.jobSec {
  /* background-color: #e8e9eb; */
  width: 110%;
  background-color: rgba(161, 166, 179, 0.085);
  border: none;
}
.hr-theme-slash-2 {
  display: flex;
}
.nav-height {
  margin-top: 2px;
  border-bottom: 2px solid rgba(219, 219, 219,1);
}
.hr-line {
  width: 100%;
  position: relative;
  margin: 15px;
  border-bottom: 1px solid #c5c7c9;
}
.hr-icon {
  position: relative;
  color: #757778;
  font-size: 10px;
  border: 2px solid #c5c7c9;
}
@media (max-width: 600px) {
  label {
    font-size: 13px;
  }
  .navbar {
    padding: 0px 0px 0px 0px !important;
    position: fixed;
    background-color: #ffffff;
    width: 0% !important;
    z-index: 1;
  }
  .nav-height {
    border-bottom: none;
  }
}
@media (max-width: 900px) {
  label {
    font-size: 13px;
  }
  .sidebar-backgroundheader {
    background-color: #f0f2f5;
  }
  .navbar-collapse {
    position: fixed;
    top: 0px;
    left: 0;
    /* padding-left: 15px; */
    padding-right: 15px;
    padding-bottom: 15px;
    width: 62%;
    height: 100%;
  }

  .navbar-collapse.collapsing {
    left: -75%;
    transition: height 0s ease;
  }
  .nav-height {
    border-bottom: none;
  }
  .navbar-collapse.show {
    left: 0;
    transition: left 300ms ease-in-out;
  }

  .navbar-toggler.collapsed ~ .navbar-collapse {
    transition: left 500ms ease-in-out;
  }
}
@media screen and (min-width : 100px) {
  .sidebar-background{
    height: 100vh !important;
    overflow-y: auto !important;
    padding-bottom: 100px !important;
  }
  .sidebar-background::-webkit-scrollbar {
  display: none;
}
}
@media (max-width: 430px) {
  .navbar {
    padding: 0px 0px 0px 0px !important;
    position: fixed;
    background-color: #ffffff;
    width: 0% !important;
    z-index: 1;
  }
  .navbar-collapse {
    position: fixed;
    top: 0px;
    left: 0;
    /* padding-left: 15px; */
    padding-right: 15px;
    padding-bottom: 15px;
    width: 100%;
    height: 100%;
  }
}
</style>
